/* eslint-disable react/prop-types */
import React from 'react';
import { CardHeader } from 'reactstrap';
import { Button, Statistic, Result } from 'antd';
import _ from 'lodash';
import { useHistory } from 'react-router';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import colors from 'constants/colors';
import { add, get, remove } from 'helpers/QueryHelper';
import notificationWithIcon from 'components/Notification/notificationWithIcon';
import { studentUnitExercise } from 'constants/contantsFiles';
import OlympicResultDetail from '../OlympicResultDetail';

import Bad from './imgs/Bad.svg';
import Good from './imgs/Good.svg';
import Great from './imgs/Great.svg';
import Perfect from './imgs/Perfect.svg';
import './styles.css';

const OlympicResults = ({ data, examination, back, loggedInUser, isTeacher }) => {
  const [isModalVisible, setModalVisible] = React.useState(false);
  const [questionIndex, setQuestionIndex] = React.useState(0);
  const history = useHistory();

  const correctQuestions = _.reduce(
    data,
    (sum, item) => {
      const value = item.userData.result ? 1 : 0;
      return sum + value;
    },
    0,
  );
  const total = examination?.questions?.length;
  const correctPercent = (correctQuestions / total) * 100;
  let correctIcon = Bad;
  if (correctPercent >= 50 && correctPercent < 75) {
    correctIcon = Good;
  } else if (correctPercent >= 75 && correctPercent < 100) {
    correctIcon = Great;
  } else {
    correctIcon = Perfect;
  }

  const saveToServer = React.useCallback(
    () => {
      const score = Math.fround(correctPercent / 10);
      return add(
        'Assignments_Answers',
        {
          StudentId: loggedInUser?.id,
          ExamId: examination?.id,
          Type: 'UNIT',
          JsonData: JSON.stringify({ data, examination }),
          Score: score,
          TeacherNoteS: '',
          Notes: '',
        },
        'CLASSWORK',
      );
    },
    [correctPercent, data, examination, loggedInUser],
  );

  React.useEffect(() => {
    if (!isTeacher && studentUnitExercise) {
      saveToServer().then(() => {
        const parameters = {
          StudentId: loggedInUser?.id,
          ExamId: examination?.id,
        };
        const sort = 'CreatedDate DESC';
        // lấy danh sách bài làm đã gửi
        get('Assignments_Answers', '*', parameters, sort, 'CLASSWORK', 'SACHSO').then(x => {
          // tìm và xóa các bài làm với index > 0;
          x.forEach((item, index) => {
            if (index) {
              remove('Assignments_Answers', item.id, 'CLASSWORK');
            }
          });
        });
        notificationWithIcon('success', 'Thông báo', 'Kết quả bài làm đã được gửi.');
      });
    }
  }, [examination?.id, isTeacher, loggedInUser?.id, saveToServer]);

  return (
    <div>
      {!isTeacher &&
        <CardHeader className="mb-3 mt-7">
          <h3>{`Kết quả làm bài của đề thi số ${examination.code}`.toUpperCase()}</h3>
        </CardHeader>}
      <div className="d-flex flex-column flex-lg-row">
        {
          !isTeacher &&
          <div className="col col-lg-4 p-0 pr-lg-2 pl-0 mb-3">
            <CardHeader>
              <Result
                style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center' }}
                status='success'
                // icon={
                //   <div className="d-flex justify-content-center">
                //     <img src={correctIcon} alt="" />
                //   </div>
                // }
                title='Bạn đã hoàn thành bài thi'
                subTitle={
                  <div className='d-flex justify-content-center'>
                    <Statistic title='Kết quả' suffix={` / ${total}`} value={correctQuestions} valueStyle={{ fontSize: 16, fontWeight: 600 }} style={{ marginRight: 32 }} />
                    <Statistic precision={2} title='Đạt tỷ lệ' suffix='%' value={correctPercent} valueStyle={{ fontSize: 16, fontWeight: 600 }} />
                  </div>
                }
                extra={!isTeacher &&
                  [
                    <Button
                      color='primary'
                      key='console'
                      onClick={async () => {
                        // TODO: Clear all redux of olympic
                        history.push(back ?? `/lms/${studentUnitExercise ? 'home' : 'olympic/home'}`);
                      }}
                    >
                      Quay về trang chủ
                    </Button>,
                  ]}
              />
            </CardHeader>
          </div>
        }
        <div className={isTeacher ? 'col-12' : 'col col-lg-8 p-0 pr-0 pl-lg-2'}>
          <CardHeader className="p-0">
            {
              data.length < 1 &&
              <Result
                status="404"
                title="KHÔNG CÓ DANH SÁCH BÀI LÀM"
                subTitle="Danh sách bài đã làm không có hoặc chưa làm."
              // extra={<Button type="primary">Back Home</Button>}
              />
            }
            {data.sort((a, b) => a.question.id - b.question.id).map((item, index) => {
              const { question, userData } = item;
              const isCorrect = userData.result;
              return (
                <div key={question.id} className="d-flex justify-content-between py-3 px-3" style={{ borderBottom: '1px solid #f1eeee' }}>
                  <div className="d-flex flex-grow-1 align-items-md-center">
                    <div className="d-flex pl-0 align-items-center mr-3">
                      <div className="mr-2">
                        {isCorrect ? <CheckCircleFilled style={{ color: colors.theme.successBold, fontSize: 24 }} /> : <CloseCircleFilled style={{ color: colors.theme.danger, fontSize: 24 }} />}
                      </div>
                      <div style={{ fontWeight: 600 }}>
                        {`Câu ${question.id}`}
                      </div>
                    </div>
                    <div style={{ color: colors.gray }} className="pl-0 col col-md-9">{question.title}</div>
                  </div>
                  <Button
                    // shape='circle'
                    type="dashed"
                    // icon={<MoreOutlined />}
                    onClick={() => { setModalVisible(!isModalVisible); setQuestionIndex(index); }}
                  >
                    Chi tiết
                  </Button>
                </div>
              );
            })}
          </CardHeader>
        </div>
        {
          isModalVisible &&
          <OlympicResultDetail data={data} questionIndex={questionIndex} visible={isModalVisible} setModalVisible={setModalVisible} />
        }
      </div>
    </div>
  );
};

export default OlympicResults;
